"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRootBuilder = void 0;
const react_1 = __importDefault(require("react"));
const RootViewController_1 = require("./RootViewController");
const Router_1 = require("./Router");
class RootRouter extends Router_1.Router {
    constructor(interactable, viewController) {
        super(interactable);
        this.viewController = viewController;
    }
    didLoad() {
        const _super = Object.create(null, {
            didLoad: { get: () => super.didLoad }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.didLoad.call(this);
            yield this.interactable.activate();
        });
    }
}
class DefaultRootBuilder {
    constructor(fabric, deps) {
        this.fabric = fabric;
        this.deps = deps;
    }
    build() {
        const { interactor, component, router } = this.fabric(this.deps);
        const viewController = new RootViewController_1.RootViewController(component ? () => react_1.default.createElement(component, Object.assign({}, interactor)) : undefined);
        return {
            router: router || new RootRouter(interactor, viewController),
            actionable: interactor
        };
    }
}
exports.DefaultRootBuilder = DefaultRootBuilder;
//# sourceMappingURL=DefaultRootBuilder.js.map